import { render } from "./Bottom.vue?vue&type=template&id=56ecc1ae&scoped=true"
const script = {}

import "./Bottom.vue?vue&type=style&index=0&id=56ecc1ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ecc1ae"]])

export default __exports__